<template>
  <div style="height: 100%; display: flex">
    <div style="flex: 3"></div>
    <div v-if="accountCreated == false" class="container" style="flex: 7">
      <h1 class="text-center">Set up your account</h1>
      <div class="mt-4" style="width: 300px; height: 50px; border: 1px solid gray">
        <v-text-field v-model="firstName" solo flat label="First Name"></v-text-field>
      </div>
      <div class="mt-4" style="width: 300px; height: 50px; border: 1px solid gray">
        <v-text-field v-model="lastName" solo flat label="Last Name"></v-text-field>
      </div>
      <div class="mt-4" style="width: 300px; height: 50px; border: 1px solid gray">
        <v-text-field v-model="username" solo flat label="Username"></v-text-field>
      </div>
      <div class="mt-4" style="width: 300px; height: 50px; border: 1px solid gray">
        <v-text-field v-model="password" solo flat label="Password" type="password"></v-text-field>
      </div>
      <div class="mt-4" style="width: 300px; height: 50px; border: 1px solid gray">
        <v-text-field v-model="confirmedPassword" solo flat label="Confirm password" type="password"></v-text-field>
      </div>
      <v-btn
        dark
        color="light-blue darken-3"
        width="300"
        height="50"
        class="mt-5 font-weight-bold"
        style="font-size: 14px"
        @click="createAccountPressed"
      >
        Create Account
      </v-btn>
      <p class="mt-4 ml-3 mb-0" style="width: 360px;">
        Make sure your password is at least 8 characters including a number and a lowercase letter.
        Read some documentation on
        <a href="https://help.github.com/articles/creating-a-strong-password/"> safer password practices</a>.
      </p>
    </div>
    <div v-else class="container">
      <h1 class="text-center">Set up your account</h1>
      <p  class="mt-4 text-center">Your account has been created!</p>
      <v-btn
        color="white"
        width="300"
        height="50"
        class="mt-5 text-capitalize font-weight-bold"
        @click="redirectToLoginPage"
      >
        Go to sign in
      </v-btn>
    </div>
    <div style="flex: 3; align-self: flex-end">
      <v-alert
        class="mr-0 mb-4"
        :value="showAlert"
        width="300"
        height="50"
        dark
        color="red"
        dismissible
        transition="slide-x-reverse-transition"
        >{{ alertMsg }}</v-alert
      >
    </div>
  </div>
</template>

<script>
import AuthService from "@/services/authService";

// ****NOTEEE***: Revamp the transitions for the v-alert when you get the chance

export default {
  name: "AccountActivation",
  components: {},
  data() {
    return {
      accountCreated: false,
      firstName: null,
      lastName: null,
      username: null,
      password: null,
      confirmedPassword: null,
      showAlert: false,
      alertMsg: "All fields required",
      accountCreateDisabled: false,
    };
  },
  methods: {
    hideAlert: function() {
      // `event` is the native DOM event
      setTimeout(() => {
        this.showAlert = false;
        this.accountCreateDisabled = false;
      }, 3000);
    },
    // Checking if the password entered contains at least one lowercase letter.
    containsLowerCaseLetter(password) {
      return /[a-z]/.test(password);
    },
    // Checking if the password entered contains at least one digit.
    containsNumber(password) {
      return /\d/.test(password);
    },
    createAccountPressed() {
      if (this.accountCreateDisabled == false) {
        const passwordsDoNotMatch = this.password != this.confirmedPassword;
        const noLowerCaseLetter = this.containsLowerCaseLetter(this.password) == false;
        const noNumber = this.containsNumber(this.password) == false;
        if (!this.firstName || !this.lastName || !this.username || !this.password || !this.confirmedPassword) {
          this.alertMsg = "All fields required";
          this.createAccountDisabled = true;
          this.showAlert = true;
          this.hideAlert();
        } else if (passwordsDoNotMatch) {
          this.alertMsg = "Passwords do not match";
          this.createAccountDisabled = true;
          this.showAlert = true;
          this.hideAlert();
        } else if (noLowerCaseLetter || noNumber || this.password.length < 8) {
          console.log(noLowerCaseLetter);
          console.log(noNumber);
          console.log(this.password.length < 8);
          console.log(this.password);
          this.alertMsg = "Invalid password";
          this.createAccountDisabled = true;
          this.showAlert = true;
          this.hideAlert();
        } else {
          var data = {
            firstName: this.firstName,
            lastName: this.lastName,
            username: this.username,
            password: this.password,
          };
          AuthService.addNewUserAccount(this.$route.params.token, data)
            .then((response) => {
              if (response.data == "account created!") {
                this.accountCreated = true; // This will change the display of this component
              } else {
                this.alertMsg = response.data;
                this.createAccountDisabled = true;
                this.showAlert = true;
                this.hideAlert();
              }
            })
            .catch((e) => {
              console.log(e);
            });
        }
      }
    },
    redirectToLoginPage() {
      this.$router.push("/");
    },
  },
  beforeMount() {
    const nameSplitIndex = this.$route.params.name.indexOf('_');
    if (nameSplitIndex > -1) {
        this.lastName = this.$route.params.name.substring(nameSplitIndex+1);
        this.lastName = this.lastName.charAt(0).toUpperCase() + this.lastName.slice(1);
        this.firstName = this.$route.params.name.substring(0, nameSplitIndex);
    } else {
        this.firstName = this.$route.params.name;
    }
    this.firstName = this.firstName.charAt(0).toUpperCase() + this.firstName.slice(1);
  }
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

/*.container.my-font {
  font-family: "Alegreya Sans";
}*/

#no-background-hover::before {
  background-color: transparent !important;
}

.remember-password-btn {
  color: #01579b;
}

.remember-password-btn:hover {
  color: black;
}
</style>
